export default class AbstractWebSocket {
  eventMap = new Map();

  constructor(options) {
    this.options = options || {};
    this.bindOnline = this.online.bind(this);
    this.bindOffline = this.offline.bind(this);
    self.addEventListener('online', this.bindOnline);
    self.addEventListener('offline', this.bindOffline);
  }

  connect(url, options) {
    throw new Error(`请实现该函数 ${options}`);
  }

  on(event, fn) {
    let fnSet = this.eventMap.get(event);
    if (!fnSet) {
      this.eventMap.set(event, new Set());
      fnSet = this.eventMap.get(event);
    }
    fnSet.add(fn);
    return this;
  }

  off(event, fn) {
    const fnSet = this.eventMap.get(event);
    if (!fnSet) {
      return this;
    }
    fnSet.delete(fn);
    return this;
  }

  fire(event, ...args) {
    const fnSet = this.eventMap.get(event);
    // console.log('fire', fnSet, ...args);
    if (fnSet) {
      fnSet.forEach(fn => Reflect.apply(fn, null, args));
    }
  }

  online() {}
  offline() {}

  destroy() {
    self.removeEventListener('online', this.bindOnline);
    self.removeEventListener('offline', this.bindOffline);
    this.eventMap.clear();
    this.eventMap = null;
    this.options = null;
  }
}
